import { useDispatch } from "react-redux";
import { ORDER_STATUS } from "../../../domain/Orders/OrderStatus";
import { ordersActions } from "../../../_store/order.slice";
import { orderViewsActions } from "../../../_store/orderView.slice";
import { WeighbridgeTicketsToOrderForm } from "./form/WeighbridgeTicketsToOrderForm";
import { mapWeighbridgeTicketsPayload } from "./form/mapWeighbridgeTicketsPayload";

export function AttachWeighbridgeTicketsToOrder({ orderId, order }) {
  const dispatch = useDispatch();
  const { status } = order || {};
  const isFormReadonly = status === ORDER_STATUS.CLOSED || status === ORDER_STATUS.CANCELLED;

  const onSubmit = async (payload) => {
    if(isFormReadonly) {
      return { error: { message: "Status zlecenia nie pozwala na zmianę kwitów wagowych." } };
    }

    const weighbridgeTickets = mapWeighbridgeTicketsPayload(payload.weighbridgeTickets);

    const requestPayload = {
      orderId,
      weighbridgeTickets,
      overrideWasteDetails: payload.overrideWasteDetails,
      bypassTicketDuplicationValidation: payload.bypassTicketDuplicationValidation,
      isFormReadonly
    }
    const response = await dispatch(ordersActions.attachWeighbridgeTickets({ orderId, payload: requestPayload }));
    if (!response?.error) {
      dispatch(orderViewsActions.getWastesDetails({ id: orderId }));
      dispatch(orderViewsActions.refreshHistory({ id: orderId }));
    }

    return response;
  };

  return <WeighbridgeTicketsToOrderForm
    order={order}
    onSubmit={onSubmit}
  />;
}